import styled from "styled-components";

import { spin } from "@/styles/Mixins";
export const OutlinkWrapper = styled.div`
  position: relative;
`;

export const Counter = styled.span`
  font-weight: 800;
  width: 18px;
  text-align: center;
`;

export const TimerIconWrapper = styled.span`
  margin-right: 15px;
  @media ${(props: any) => props.theme.breakpoints.mobile} {
    margin-right: 10px;
  }
`;

export const TimeoutOverlay = styled.div`
  position: absolute;
  top: -50px;
  height: 50px;
  width: 100%;
  align-items: center;
  justify-content: center;
  display: flex;
  color: ${(props: any) => props.theme.colors.black};
  text-transform: uppercase;
  font-size: 12px;

  @media ${(props: any) => props.theme.breakpoints.mobile} {
    top: -30px;
    height: 30px;
    font-size: 11px;
  }
`;

export const ImageLinkBox = styled.a`
  display: flex;
  width: 100%;
  max-height: 430px;
  font-size: ${(props: any) => props.theme.typography.h800};
  align-items: flex-start;
  justify-content: center;
  overflow: auto;
`;

export const ImageLinkLoading = styled.span`
  border-radius: 50%;
  width: 50px;
  height: 50px;
  border: 3px solid ${(props: any) => props.theme.colors.primary100};
  border-top-color: ${(props: any) => props.theme.colors.primary};
  animation: ${spin} 750ms infinite linear;
`;

export const ImageBox = styled.img`
  display: block;
  margin: 0 auto;
  max-width: 100%;
  height: auto;
  overflow: hidden;
  @media ${(props: any) => props.theme.breakpoints.mobile} {
    min-height: auto;
  }
`;
